import { FC } from 'react';

import { FOR_BANK_SECTIONS, FOR_BANK_SUB_SECTIONS } from 'constants/businessToolSections/forBank';

import useCheckSubSectionAccess from 'hooks/useCheckSubSectionAccess';

import { InDirectFormTable } from './InDirectFormComponents/InDirectFormTable';
import { FullScreenWrapper } from '../../components/FullScreenWrapper';
import { ProjectedCashFlowHeader } from '../components/ProjectedCashFlowHeader/ProjectedCashFlowHeader';

const FormComponent = ({ disabled }: { disabled: boolean }) => {
  return (
    <>
      <ProjectedCashFlowHeader disabled={disabled} />
      <InDirectFormTable disabled={disabled} />
    </>
  );
};

export const InDirectForm: FC = () => {
  const canAccess = useCheckSubSectionAccess(
    FOR_BANK_SECTIONS.FINANCIAL_PLAN,
    FOR_BANK_SUB_SECTIONS.FOR_BANK_FINANCIAL_PLAN.PLANNED_EXPENSES,
  );
  return (
    <FullScreenWrapper title=' '>
      <FormComponent disabled={!canAccess} />
    </FullScreenWrapper>
  );
};
